@let items = model.items$();

<div *ngIf="items && items.length > 0" class="navigator-bar" data-link-ga-node="NavigatorBar">
  <ng-container *ngFor="let item of items">
    <div *ngIf="item.type === 'url' || item.type === 'action'"
         class="navigator-bar-item"
         [attr.data-link-ga-node]="item.label"
         [class.active]="item.active"
         (click)="itemSelected(item, $event)">
      {{item.label! | translate}}
    </div>

    <div *ngIf="item.type === 'separator'" class="navigator-bar-separator"></div>
  </ng-container>
</div>
